/**
* Pinned Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Pinned Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'pinned-left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      const query = window.matchMedia( '(prefers-reduced-motion: reduce)' );

      if ( !query.matches ) {
        $( '.pinned-left-right' ).each( function( key, val ) {
          if ( window.innerWidth > 768 ) {
            let topOffset = $( 'header' ).height();
            if ( $( 'body.logged-in' ).length > 0 ) {
              topOffset += 32;
            }
            let contentHeight = 50;

            const content = $( '.pinned-left-right__content' );
            content.each( function( i ) {
              if ( i+1 != content.length ) {
                contentHeight = contentHeight + $( this ).outerHeight();
              }
            } );

            const st = ScrollTrigger.create( {
              trigger: $( this ),
              pin: '.images-area',
              start: `top top+=40px`,
              end: `top top-=${contentHeight}px`,
            } );
            content.each( function( i ) {
              const image = '#'+$( this ).data( 'content-section' );
              const tl = gsap.timeline( {
                scrollTrigger: {
                  trigger: this,
                  start: `top top+=${topOffset}`,
                  end: `bottom top+=${topOffset}`,
                  // markers: true,
                  onEnter: ( {progress, direction, isActive} ) => {
                    $( image ).addClass( 'active' );
                  },
                  onLeave: ( {progress, direction, isActive} ) => {
                    if ( i+1 !== content.length ) {
                      $( image ).removeClass( 'active' );
                    }
                  },
                  onEnterBack: ( {progress, direction, isActive} ) => {
                    $( image ).addClass( 'active' );
                  },
                  onLeaveBack: ( {progress, direction, isActive} ) => {
                    if ( i !== 0 ) {
                      $( image ).removeClass( 'active' );
                    }
                  },
                },
              } );
              tl.to( $( image ), {
                addClass: 'active',
              } );
            } );
          }
        } );
      } else {
        $( '.pinned-left-right__no-animation' ).css( 'display', 'block' );
        $( '.pinned-left-right__animation' ).css( 'display', 'none' );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'pinned-left-right', COMPONENT );
} )( app );
